// Customer-merge defaults for AdminMerge. Mirrors sentinelroom.com/admin/merge (Library repo,
// public/js/merge.js autoSelect) so both merge screens make the same choices.
//
// Consent is deliberately NOT a staff choice: merge-customers moves email consent with the
// email and SMS consent with the phone (Library supabase/functions/merge-customers/merge-fields.ts).

type Side = "a" | "b";
// deno-lint-ignore no-explicit-any
type Row = Record<string, any> | null | undefined;

/** Keep the account with more history: more tastings, then the older account. */
export function defaultCustomerPrimary(a: Row, b: Row): Side {
  const ta = a?.tastings_count || 0;
  const tb = b?.tastings_count || 0;
  if (ta !== tb) return ta > tb ? "a" : "b";
  return new Date(a?.created_at || 0).getTime() <= new Date(b?.created_at || 0).getTime() ? "a" : "b";
}

/**
 * Which record's Square id to keep. After a merge in Square only one record stays live — the one
 * Square updated most recently. Null when at most one side has an id: nothing to choose, because
 * merge-customers fills a missing id from the other record automatically.
 */
export function defaultSquareIdSide(a: Row, b: Row): Side | null {
  if (!a?.square_customer_id || !b?.square_customer_id) return null;
  const ua = new Date(a.square_updated_at || 0).getTime();
  const ub = new Date(b.square_updated_at || 0).getTime();
  return ua >= ub ? "a" : "b";
}

/** field_overrides for merge-customers' execute-merge: only the Square id is a staff choice. */
export function customerFieldOverrides(primary: Side, squareIdSide: Side | null): Record<string, "secondary"> | undefined {
  return squareIdSide && squareIdSide !== primary ? { square_customer_id: "secondary" } : undefined;
}
